export default "__VITE_ASSET__BMYGxaI7__"